export default category => `/shop/${category}`
